import { C48ReputationScheduleCTAProps } from './C48ReputationScheduleCTA.types';
import { ReputationScheduleCtaProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';
import { getKvpValue } from 'src/shared/field-utils';

export function CreateReputationScheduleCTAModel(
  props: C48ReputationScheduleCTAProps | undefined,
  doctorSearchURL: string,
  locationSearchURL: string
): ReputationScheduleCtaProps {
  type t = ReputationScheduleCtaProps;
  const { params, fields } = props || {};
  const { renderText, renderRichText } = useConditionalRendering();

  const topColorBar = getDroplink<t['topColorBar']>(params?.TopBorderColor, 'none');
  const headlineTag = getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p');
  const filterType = getKvpValue<t['filterType']>(fields?.FilterType, 'specialties');
  const searchType = getKvpValue<t['searchType']>(fields?.SearchType, 'Doctor');

  const model: ReputationScheduleCtaProps = {
    buttonText: renderText(fields?.ButtonText) || 'Schedule online',
    errorMessage:
      renderRichText(fields?.ErrorMessage) || 'Enter city, state and/or ZIP is required',
    filterText: props?.fields?.FilterText?.value ?? '',
    filterType,
    headline: renderText(fields?.Headline),
    icon: props?.fields?.Icon?.fields?.Value?.value as t['icon'],
    searchLabel: renderText(fields?.InputLabel),
    placeholderText: props?.fields?.PlaceholderText?.value ?? '',
    searchType,
    supportCopy: renderRichText(fields?.SupportCopy),
    headlineTag,
    topColorBar,
    searchUrl: searchType === 'Location' ? locationSearchURL : doctorSearchURL,
  };

  return model;
}
